export const QR_STATES = {
  IDLE: "idle",
  OPEN: "open",
  SUCCESS: "success",
  FAIL: "fail",
};
